module.exports = __webpack_public_path__ + "img/Dumfries_&_Galloway.65cc9e81.png";